import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

// prettier-ignore
const styles = tv({
    slots: {
        container: `
      iris:flex
      iris:w-full
      iris:h-full
      iris:rounded-(--comp-size-radius-card)
      iris:border-(length:--comp-size-border-card)
    `,
    },
    variants: {
        imagePosition: {
            top: {
                container: `iris:flex-col`,
            },
            left: {
                container: `iris:flex`,
            },
            full: {
                container: 'iris:relative',
            },
        },
        interactive: {
            true: `
        iris:cursor-pointer 
        iris:outline-none
      `,
            false: "",
        },
        variant: {
            standard: {
                container: `
          iris:border-(--comp-color-border-card-standard)
          iris:bg-(--comp-color-background-card-standard)
        `,
            },
            subtle: {
                container: `
          iris:border-(--comp-color-border-card-subtle)
          iris:bg-(--comp-color-background-card-subtle)
        `,
            },
            brand: {
                container: `
          iris:border-(--comp-color-border-card-brand)
          iris:bg-(--comp-color-background-card-brand)
        `,
            },
            "brand-subtle": {
                container: `
          iris:border-(--comp-color-border-card-brand-subtle)
          iris:bg-(--comp-color-background-card-brand-subtle)
        `,
            },
        },
        inverse: {
            true: "",
            false: "",
        },
    },
    compoundVariants: [
        {
            variant: "standard",
            inverse: true,
            class: {
                container: `
          iris:border-(--comp-color-border-card-standard-inverse)
          iris:bg-(--comp-color-background-card-standard-inverse)
        `,
            },
        },
        {
            variant: "subtle",
            inverse: true,
            class: {
                container: `
          iris:border-(--comp-color-border-card-subtle-inverse)
          iris:bg-(--comp-color-background-card-subtle-inverse)
        `,
            },
        },
        {
            variant: "brand",
            inverse: true,
            class: {
                container: `
          iris:border-(--comp-color-border-card-brand-inverse)
          iris:bg-(--comp-color-background-card-brand-inverse)
        `,
            },
        },
        {
            variant: "brand-subtle",
            inverse: true,
            class: {
                container: `
          iris:border-(--comp-color-border-card-brand-subtle-inverse)
          iris:bg-(--comp-color-background-card-brand-subtle-inverse)
        `,
            },
        },
        {
            inverse: false,
            interactive: true,
            class: focusStyles.default
        },
        {
            inverse: true,
            interactive: true,
            class: focusStyles.inverse,
        },
    ],
});

export { styles as default };
